export const heroData = {
  title: '美女内裤精选指南',
  subtitle: '从材质到款式，从尺码到品牌',
  description: '我们深知，一条好的内裤是女性一天舒适的开始。这里汇集了最全面的内裤选购知识，帮你找到真正适合的那一条——兼顾舒适与时尚，让每一天都从内而外散发自信。',
  ctaText: '开始探索',
  ctaLink: '/category/all',
  secondaryText: '了解更多',
  secondaryLink: '/about',
};

export const categoryCards = [
  {
    id: 'cailiao',
    title: '按材质选购',
    description: '棉质、真丝、莫代尔、竹纤维……不同材质带来截然不同的穿着体验',
    icon: 'ri-shirt-line',
    slug: 'cailiao',
    image: 'https://readdy.ai/api/search-image?query=Soft%20natural%20cotton%20and%20silk%20fabric%20textures%20elegantly%20draped%20on%20a%20neutral%20cream%20background%2C%20gentle%20diffused%20natural%20lighting%2C%20minimalist%20product%20photography%20style%2C%20soft%20warm%20tones%2C%20clean%20aesthetic%2C%20high%20detail%20fabric%20weave%20visible&width=800&height=600&seq=cat-material&orientation=landscape',
  },
  {
    id: 'kuanshi',
    title: '按款式选购',
    description: '三角裤、平角裤、丁字裤、高腰款……选对款式才能舒适一整天',
    icon: 'ri-pantone-line',
    slug: 'kuanshi',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20flat%20lay%20of%20various%20fabric%20swatches%20in%20soft%20pastel%20and%20warm%20neutral%20tones%2C%20arranged%20artistically%20on%20a%20cream%20linen%20background%2C%20soft%20natural%20window%20light%2C%20editorial%20lifestyle%20photography%2C%20clean%20and%20sophisticated&width=800&height=600&seq=cat-style&orientation=landscape',
  },
  {
    id: 'changjing',
    title: '按场景选购',
    description: '日常通勤、运动健身、特殊日子、睡眠穿着……不同场景有不同选择',
    icon: 'ri-sun-line',
    slug: 'changjing',
    image: 'https://readdy.ai/api/search-image?query=Aesthetic%20flat%20lay%20of%20elegant%20fabric%20pieces%20in%20warm%20blush%20and%20cream%20colors%20with%20soft%20shadows%2C%20arranged%20on%20a%20textured%20natural%20linen%20surface%2C%20gentle%20morning%20sunlight%2C%20minimalist%20editorial%20style%2C%20feminine%20and%20delicate%20composition&width=800&height=600&seq=cat-scene&orientation=landscape',
  },
  {
    id: 'pinpai',
    title: '按品牌选购',
    description: '30+品牌真实评测，从平价到高端，帮你找到最值得入手的品牌',
    icon: 'ri-award-line',
    slug: 'pinpai',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20fabric%20swatches%20in%20soft%20rose%20and%20champagne%20tones%20elegantly%20displayed%20on%20a%20marble%20surface%20with%20warm%20ambient%20lighting%2C%20premium%20textile%20photography%2C%20subtle%20elegance%2C%20high%20fashion%20editorial%20vibe&width=800&height=600&seq=cat-brand&orientation=landscape',
  },
];

export const featuredArticles = [
  {
    id: 'article-1',
    title: '2026年最值得入手的10款女士内裤推荐',
    excerpt: '经过30天实测对比，从舒适度、透气性、耐穿性三个维度，为你精选出今年最值得购买的女士内裤，涵盖多个价位和风格。',
    category: '品牌推荐',
    categorySlug: 'pinpai',
    slug: '2026-top-10-recommendations',
    date: '2026-08-05',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Beautifully%20arranged%20soft%20fabric%20textiles%20in%20blush%20pink%20and%20cream%20tones%20on%20a%20clean%20white%20surface%2C%20elegant%20minimalist%20flat%20lay%2C%20warm%20natural%20light%2C%20editorial%20lifestyle%20photography%2C%20feminine%20and%20sophisticated&width=800&height=500&seq=article-1&orientation=landscape',
  },
  {
    id: 'article-2',
    title: '内裤材质终极对比：棉质 vs 莫代尔 vs 真丝',
    excerpt: '不同材质的内裤在透气性、吸湿性、亲肤感上差异巨大。我们做了详细对比测试，帮你找到最适合自己肤质的内裤材质。',
    category: '材质对比',
    categorySlug: 'cailiao',
    slug: 'fabric-comparison-guide',
    date: '2026-08-03',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Three%20different%20fabric%20textures%20cotton%20modal%20and%20silk%20elegantly%20displayed%20side%20by%20side%20on%20a%20neutral%20warm%20background%2C%20macro%20texture%20details%20visible%2C%20soft%20diffused%20lighting%2C%20product%20photography%20style%2C%20clean%20aesthetic&width=800&height=500&seq=article-2&orientation=landscape',
  },
  {
    id: 'article-3',
    title: '女士内裤尺码怎么选？完整测量指南',
    excerpt: '80%的女性穿着不适合自己尺码的内裤！学会正确的臀围、腰围测量方法，找到最适合自己的内裤尺码。',
    category: '尺码指南',
    categorySlug: 'chima',
    slug: 'size-measurement-guide',
    date: '2026-08-01',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20measuring%20tape%20and%20soft%20fabric%20on%20a%20warm%20cream%20surface%20with%20gentle%20shadows%2C%20minimalist%20flat%20lay%20composition%2C%20soft%20natural%20lighting%2C%20feminine%20delicate%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=article-3&orientation=landscape',
  },
  {
    id: 'article-4',
    title: '夏季透气内裤推荐：告别闷热不适',
    excerpt: '夏天穿错内裤的后果很严重！精选透气性最好的女士内裤，让你整个夏天清爽舒适，远离妇科困扰。',
    category: '场景选购',
    categorySlug: 'changjing',
    slug: 'summer-breathable-guide',
    date: '2026-07-28',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Light%20airy%20fabric%20draped%20gracefully%20in%20soft%20pastel%20colors%20by%20a%20sunlit%20window%2C%20breezy%20summer%20vibe%2C%20clean%20minimalist%20aesthetic%2C%20warm%20natural%20light%2C%20feminine%20and%20fresh%20editorial%20style&width=800&height=500&seq=article-4&orientation=landscape',
  },
  {
    id: 'article-5',
    title: '运动内衣与内裤搭配指南：运动也要舒适',
    excerpt: '运动时的内裤选择直接影响运动体验。无痕、速干、高弹……运动场景下内裤怎么选？我们给你最专业的建议。',
    category: '场景选购',
    categorySlug: 'changjing',
    slug: 'sports-underwear-guide',
    date: '2026-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Athletic%20fabric%20textures%20in%20soft%20neutral%20tones%20elegantly%20draped%2C%20activewear%20aesthetic%2C%20minimalist%20flat%20lay%20on%20light%20wood%20surface%2C%20clean%20and%20modern%20product%20photography%2C%20soft%20natural%20light&width=800&height=500&seq=article-5&orientation=landscape',
  },
  {
    id: 'article-6',
    title: '蕾丝内裤的选购与保养全攻略',
    excerpt: '蕾丝内裤性感又好看，但选不好容易扎皮肤、洗几次就变形。掌握正确的选购和保养方法，让蕾丝内裤持久美丽。',
    category: '款式推荐',
    categorySlug: 'kuanshi',
    slug: 'lace-underwear-care-guide',
    date: '2026-07-22',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Delicate%20lace%20fabric%20texture%20in%20soft%20blush%20pink%20tone%2C%20close%20up%20macro%20photography%20showing%20intricate%20lace%20patterns%2C%20warm%20natural%20light%2C%20feminine%20elegant%20aesthetic%2C%20soft%20cream%20background&width=800&height=500&seq=article-6&orientation=landscape',
  },
];

export const faqData = [
  {
    question: '女士内裤多久更换一次最合适？',
    answer: '一般建议内裤穿着3-6个月后更换。当发现内裤出现变形、发黄、弹性减退、面料变薄等情况时，就应及时更换。日常最好准备10-15条轮换穿着，延长每条内裤的使用寿命。此外，经期专用内裤建议每2-3个月更换一次。',
  },
  {
    question: '什么材质的内裤最适合日常穿着？',
    answer: '日常穿着首选纯棉内裤，透气性好、亲肤柔软，对皮肤刺激最小。莫代尔材质也是不错的选择，比纯棉更丝滑柔软，吸湿性更好。真丝内裤适合敏感肌肤，但价格较高且需要精心保养。建议日常以棉质为主，特殊场合可以搭配真丝或蕾丝款式。',
  },
  {
    question: '内裤应该手洗还是机洗？',
    answer: '强烈建议手洗内裤。机洗不仅容易导致内裤变形、弹性减退，还可能与外衣交叉污染。手洗时使用温和的内衣专用洗涤液，水温控制在30°C以下，轻轻揉搓，避免用力拧绞。晾晒时避免阳光直射，最好在通风阴凉处自然晾干。',
  },
  {
    question: '高腰内裤和低腰内裤怎么选？',
    answer: '这主要取决于你的穿着习惯和体型。高腰内裤提供更好的腹部包裹感和保暖性，适合搭配高腰裤装和裙装，对腹部有小肚腩的女性有修饰效果。低腰内裤适合搭配低腰裤装，穿着更无痕。如果你的腰腹部容易受凉，建议选择中高腰款式。',
  },
  {
    question: '运动时应该穿什么样的内裤？',
    answer: '运动时建议选择专业的运动内裤，它们通常采用速干面料（如锦纶+氨纶混纺），具有出色的吸湿排汗性能。无痕设计可以减少运动摩擦，高弹力面料确保活动自如。避免穿着纯棉内裤运动，因为棉质吸汗后不易干，潮湿环境容易滋生细菌。',
  },
  {
    question: '内裤尺码选大了还是选小了更不好？',
    answer: '两者都不好，但穿小了危害更大。内裤过紧会压迫腹部、影响血液循环，还可能导致私处摩擦不适、色素沉着。内裤过松则无法起到良好的包裹和固定作用。建议用软尺准确测量臀围，对照品牌尺码表选择。如果介于两个尺码之间，建议选择较大的那个尺码。',
  },
];